import react from "react";
import Request from "../../../../api/Requests";

const getWithdrawalList = (params) => {
    return Request('admin/withdrawal-request-list', 'GET', params, true);
}

const getWithdrawalDetails = (params) => {
    return Request('admin/withdrawal-request-details', 'GET', params, true);
}

const changeWithdrawalStatus = (params) => {
    return Request('admin/withdrawal-request-change-status', 'POST', params, true);
}



export default {
    getWithdrawalList,
    getWithdrawalDetails,
    changeWithdrawalStatus
}